
export function createHTML(messageDisplayAreaRef) {
  return `
  <!DOCTYPE html>
  <html>
  <head lang="en">
    <meta charset="UTF-8">
    <title>test</title>
    <link rel="stylesheet" href="https://vm.providesupport.com/printChatTranscriptStyles.css" type="text/css">
  </head>

  <body>
    ${messageDisplayAreaRef.current.customScrollRef.innerHTML}
  </body>
  </html>
  `
}

const FILE_TRANSFER_DOWNLOAD_ADDRESS = 'https://cw2c2b.providesupport.com';
function trimStringByStrings(string, start, finish) {
  const startIndex = ~string.indexOf(start) ? (string.indexOf(start) + start.length) : 0;
  const finishIndex = ~string.indexOf(finish) ? string.indexOf(finish) : string.length;
  return string.slice(startIndex, finishIndex)
}

export function createTXT(transcript, texts, accountName) {
  /* set default values */
  transcript.visitor = transcript.visitor || {}
  transcript.visitor.name = transcript.visitor.name || ''
  transcript.agents = transcript.agents || ''

  return `${texts['transcript-txt-header']}

${texts['company']}: ${accountName}
${texts['started']}: ${new Date(transcript.startDate).toLocaleString()}
${transcript.endDate
    ? `${texts['finished']}: ${new Date(transcript.endDate).toLocaleString()}`
    : ''
}

${texts['visitor']}: ${transcript.visitor.name}
${
  transcript.assignedOperator ? `${texts['assigned-operator']}: ${transcript.assignedOperator.nickname}
` : ''}${
  transcript.acceptedOperator ? `${texts['accepted-operator']}: ${transcript.acceptedOperator.nickname}
` : ''}${
  transcript.invitedOperatorNicknames ? `${texts['invited-operator']}: ${transcript.invitedOperatorNicknames}
` : ''}
${transcript.messages.reduce((sum, message) => {
    const { authorName, text, translatedText, created } = message;
    const isFile = ~text.indexOf(FILE_TRANSFER_DOWNLOAD_ADDRESS);
    let res = ''
    if (isFile) {
      res = `${trimStringByStrings(text, '">', '</a>')} ${FILE_TRANSFER_DOWNLOAD_ADDRESS}${trimStringByStrings(text, '_ADDRESS}', '" ')}`
    } else {
      const time = created ? `${new Date(created).toLocaleString()}: ` : ''
      res = `${time}${authorName}: ${text}${translatedText ? ` | ${translatedText}` : ''}`
    }
    return `${sum}
${res}`
  }, '')}

${transcript.startChatForm
    ? `${texts['visitor-details']}
---------------${
  Object.keys(transcript.startChatForm).reduce((sum, key) => `${sum}
${key}: ${transcript.startChatForm[key]}`,
  '')}`
    : ''
}

${transcript.postChatSurvey
    ? `${texts['post-chat-survey']}
---------------
${texts['proficiency']}: ${transcript.postChatSurvey.Proficiency}
${texts['politeness']}: ${transcript.postChatSurvey.Politeness}
${texts['comments']}: ${transcript.postChatSurvey.Comments}
`
    : ''
}
`
}
